<template>
    <div class="nasabah">
        <p class="title">Nasabah Reject</p>
        <div class="content">
            <table class="table table-striped table-bordered">
                <thead class="text-center">
                    <tr>
                        <th>No</th>
                        <th>Nama Lengkap</th>
                        <th>Email</th>
                        <th>
                            Platform
                            <div class="form-group mb-0">
                                <select name="" id="" v-model="platform" @change="filterPlatform">
                                    <option value="">All</option>
                                    <option v-for="(data, i) in dataPlatform" :key="i" :value="data.code">{{ data.name }}</option>
                                </select>
                            </div>
                        </th>
                        <th>No Telepon</th>
                        <th>No KTP</th>
                        <th>NPWP</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <td colspan="9" v-show="loadingData" style="text-align: center">
                        <div class="lds-ring">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </td>
                    <tr v-for="(data, i) in dataNsb" :key="i" v-show="loadingData == false && dataNsb.length != 0">
                        <td>{{ (currentPage - 1) * perPage + (i + 1) }}</td>
                        <td>{{ data.fullname ? data.fullname : "-" }}</td>
                        <td>
                            {{ data.user.email }}
                        </td>
                        <td>
                            <div v-for="platformData in data.platform" :key="platformData.code">
                                {{ "- " + platformData.name }}
                            </div>
                        </td>
                        <td>
                            {{ data.user.phonenumber ? data.user.phonenumber : "-" }}
                        </td>
                        <td>{{ data.ktp_no ? data.ktp_no : "-" }}</td>
                        <td>{{ data.npwp_no ? data.npwp_no : "-" }}</td>
                        <td>
                            <router-link :to="'/nsb-detail/' + data._id"
                                ><button type="button" class="buttons btn-info btn-xs">
                                    Detail
                                </button></router-link
                            >
                        </td>
                    </tr>
                    <tr v-show="loadingData == false && dataNsb.length == 0">
                        <td class="text-center" colspan="8">No Data</td>
                    </tr>
                </tbody>
            </table>
            <b-pagination
                v-model="currentPage"
                :total-rows="dataNsb.length"
                :per-page="perPage"
                aria-controls="new-table"
                v-show="dataNsb.length > 10"
            ></b-pagination>
        </div>
    </div>
</template>

<script>
import axios from "axios";
export default {
    data() {
        return {
            dataNsb: [],
            number: 1,
            currentPage: 1,
            perPage: 10,
            loadingData: false,
            platform: "",
            dataPlatform: [],
        };
    },

    mounted() {
        // let setPage = (offset - 1) * this.perPage;
        axios.get("/v2/master_data/platform").then((res) => {
            this.dataPlatform = res.data.data;
        });
        this.getData(this.currentPage, this.platform);
    },

    methods: {
        filterPlatform() {
            this.getData(this.currentPage, this.platform);
        },
        getData(value, platform) {
            this.loadingData = true;
            let role = localStorage.getItem("role");
            let urlAdmin;
            if (role == "0") {
                urlAdmin = "superadmin";
            } else {
                urlAdmin = "admin-broker";
            }
            let setPage = (value - 1) * this.perPage;
            axios.get("/v2/" + urlAdmin + "/kyc/customers?state=reject&limit=10&offset=" + setPage + "&platform_code=" + platform).then((res) => {
                this.loadingData = false;
                this.dataNsb = res.data.data.customers;
            });
        },
    },
    computed: {
        checkRole() {
            let role = localStorage.getItem("role");
            if (role) {
                return role;
            } else {
                return null;
            }
        },
        paginate() {
            if (!this.dataNsb || this.dataNsb.length != this.dataNsb.length) {
                return;
            }
            var index = this.currentPage * this.perPage - this.perPage;
            return this.dataNsb.slice(index, index + this.perPage);
        },
    },
};
</script>

<style scoped>
.lds-ring {
    display: inline-block;
    /* position: absolute; */
    width: 30px;
    height: 30px;
    /* top: 4px; */
    /* left: 39%; */
}
.lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 30px;
    height: 30px;
    margin: 6px;
    border: 6px solid #1f354a;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #1f354a transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
}
@keyframes lds-ring {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

table {
    color: #707070 !important;
}

.nasabah {
    font-size: 14px;
    padding: 0 20px;
}

.title {
    font-size: 22px;
    font-weight: bold;
    margin: 0 0 60px;
}
</style>
